import React from 'react';
import PropTypes from 'prop-types';

class TextAreaAttribute extends React.Component {

  onChange = (event) => {
    this.props.onFieldValueChange(this.props.keyPath, event.target.value);
  };

  onFocus = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { touched: true, focused: true });
  };

  onBlur = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { focused: false, touched: true, hasLostFocusOnce: true });
  };

  render() {
    return this.props.include ? (
      <textarea
        style={this.props.style}
        id={this.props.id}
        aria-labelledby={this.props.labelledBy}
        className={`form-control ${this.props.className} ${this.props.invalid ? 'is-invalid' : ''}`}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    ) : null;
  }
}

TextAreaAttribute.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  keyPath: PropTypes.array.isRequired,
  labelledBy: PropTypes.string,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  include: PropTypes.bool,
  style: PropTypes.object,
};

TextAreaAttribute.defaultProps = {
  className: '',
  disabled: false,
  id: 'temp',
  invalid: false,
  labelledBy: '',
  placeholder: '',
  value: '',
  include: true,
  style: {},
};

export default TextAreaAttribute;
